import BaseComponent from 'scripts/BaseComponent.js';
import Swiper, {
  Pagination, Navigation, Lazy,
} from 'swiper';

export default class QuickShopProductImages extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      imageSlider: '.js-imageSlider',
      prevImageBtn: '.js-prevImageBtn',
      nextImageBtn: '.js-nextImageBtn',
      pagination: '.js-imageSliderPagination',
      imageCover: '.js-quickShopImageCover',
    };

    this.dom = {
      $component: component,
      $imageSlider: this.$get(this.refs.imageSlider),
      $prevImageBtn: this.$get(this.refs.prevImageBtn),
      $nextImageBtn: this.$get(this.refs.nextImageBtn),
      $pagination: this.$get(this.refs.pagination),
      $imageCover: this.$get(this.refs.imageCover),
    };

    this.state = {
      swiper: null,
      revealClass: 'reveal',
      removeClass: 'remove',
      animationTiming: 500,
    };

    this.mount();
    this.init();
  }

  mount() {
    super.mount();
  }

  init() {
    this.initSlider();
    this.bindSwiperToWindow();
  }

  initSlider() {
    const { dom, state } = this;

    state.swiper = new Swiper(dom.$imageSlider, {
      modules: [Navigation, Lazy, Pagination],
      loop: true,
      preloadImages: false,
      pagination: {
        el: dom.$pagination,
        bulletClass: 'QuickShopProductImages__bullet',
        bulletActiveClass: 'is-active-slide',
      },
      navigation: {
        prevEl: dom.$prevImageBtn,
        nextEl: dom.$nextImageBtn,
      },
      lazy: {
        loadOnTransitionStart: true,
      },
    });

    state.swiper.once('lazyImageReady', this.removeImageCover.bind(this));
  }

  bindSwiperToWindow() {
    const { state } = this;

    window.theme = window.theme || {};
    window.theme.quickShopSwiper = state.swiper;
  }

  removeImageCover() {
    const { dom, state } = this;

    dom.$imageCover.classList.add(state.revealClass);
    setTimeout(() => dom.$imageCover.classList.add(state.removeClass), state.animationTiming);
  }
}
